<template>
  <v-toolbar-items>
    <v-btn
      tile
      small
      class="main-menu px-0 mr-3"
      :class="{ 'v-btn--active': link.active }"
      text
      :ripple="false"
      v-for="(link, index) in links"
      :key="index"
      :to="link.link"
      :data-test-id="(link.meta && link.meta.id) || `${link.id}-tab`"
    >
      {{ link.title }}
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
